<template>
  <router-view />
</template>

<script>
export default {
  mounted() {
    // 메타 태그 추가
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content = "width=device-width, initial-scale=1";
    document.head.appendChild(metaTag);
  },
  beforeRouteLeave(to, from, next) {
    // 메타 태그 제거 (옵션)
    const metaTags = document.querySelectorAll('meta[name="viewport"]');
    metaTags.forEach((tag) => {
      document.head.removeChild(tag);
    });
    next();
  },
};
</script>

<style lang="scss" scoped>
</style>